import lazyScreen from '../utils/lazyScreen';
const CRMLoyaltyDetails = lazyScreen(() => import('../pages/loyalty/CRMLoyaltyDetails/index.js'), 'pages/loyalty/CRMLoyaltyDetails/index.js');

export default [
    {
        path: '/loyalty/CRMLoyaltyDetails',
        component: CRMLoyaltyDetails
    }
];
